import moment from "moment";

import {
  FETCH_POLLING_FAIL,
  FETCH_POLLING_START,
  FETCH_POLLING_SUCCESS,
  INACTIVE_ALARMS,
  NEW_ACTIVE_ALARM,
  RESET_POLLNG_STATE,
  STOP_POLLING,
  UPDATE_ALARM,
  UPDATE_ALL_ALARMS
} from "../actionTypes/polling";

const initialState = {
  systemsStatus: [null],
  activeAlarms: [],
  fetching: false,
  error: null
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_POLLING_START:
      return fetchPollingStart(state);
    case FETCH_POLLING_FAIL:
      return fetchPollingFail(state, action);
    case FETCH_POLLING_SUCCESS:
      return fetchPollingSuccess(state, action);
    case UPDATE_ALARM:
      return updateAlarm(state, action);
    case UPDATE_ALL_ALARMS:
      return updateAlarms(state, action.payload);
    case STOP_POLLING:
      return fetchPollingStop(state);
    case INACTIVE_ALARMS:
      return onInactiveAlarms(state, action.payload);
    case NEW_ACTIVE_ALARM:
      const activeAlarms = [action.payload, ...state.activeAlarms];
      return { ...state, activeAlarms };
    case RESET_POLLNG_STATE:
      return initialState;
    default:
      return state;
  }
};

function updateAlarms(state, activeAlarms) {
  activeAlarms.sort((alarm1, alarm2) => moment(alarm2.timestamp).unix() - moment(alarm1.timestamp).unix());
  return { ...state, activeAlarms };
}

function onInactiveAlarms(state, payload) {
  const { system, inActiveAlarms } = payload;
  let { activeAlarms } = state;
  if (inActiveAlarms.length) {
    activeAlarms = state.activeAlarms.filter(alarm => !(inActiveAlarms.includes(alarm.alarmId) && system === alarm.sysId));
  }
  return { ...state, activeAlarms };
}

function updateAlarm(state, action) {
  const { sysId, alarmId, readStatus } = action.payload;
  const existingAlarms = [...state.activeAlarms];
  const alarmIndex = existingAlarms.findIndex(alarm => alarm.sysId === sysId && alarm.alarmId === alarmId);
  if (alarmIndex >= 0) {
    let alarmData = existingAlarms[alarmIndex];
    alarmData = { ...alarmData, readStatus };
    existingAlarms[alarmIndex] = alarmData;
  }
  return { ...state, activeAlarms: existingAlarms };
}

function fetchPollingStart(state) {
  return {
    ...state,
    fetching: true,
    error: null
  };
}

function fetchPollingSuccess(state, action) {
  const { activeAlarms, systemsStatus } = action.payload;
  activeAlarms.sort((alarm1, alarm2) => moment(alarm2.timestamp).unix() - moment(alarm1.timestamp).unix());
  return {
    ...state,
    activeAlarms,
    systemsStatus,
    error: null,
    fetching: false
  };
}

function fetchPollingFail(state, action) {
  return {
    ...state,
    error: action.payload.error.message,
    fetching: false
  };
}

function fetchPollingStop(state) {
  return {
    ...state,
    fetching: false
  };
}

export default reducer;
